import React from 'react';

export default ({ maxValue, value, mainWrapperClassName = '', textClassName = '', barClassName = '' }) => {
  const percent = ((value / maxValue) * 100).toFixed(1);

  return (
    <div className={`progressBar_wrapper ${mainWrapperClassName}`}>
      <div className={`progressBar_text ${textClassName}`}>{`${percent}%`}</div>
      <div className={`progressBar_bar ${barClassName}`} style={{ width: `${percent}%` }} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/Components/ProgressBar.jsx